import axios from "axios";
import Cookies from "js-cookie";

export const nonAuthInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 300000,
    // headers: {
    //     "Access-Control-Allow-Origin": "*",
    //     "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    //     "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
    //     "Access-Control-Allow-Credentials": true,
    // },
});

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 300000,
    headers: {
        Authorization: `Bearer ${Cookies.get("access-token")}`,
    },
});

export const setBaseURL = (url) => {
    nonAuthInstance.defaults.baseURL = url;
    axiosInstance.defaults.baseURL = url;
};

export const setHeaderDb = (db) => {
    console.log("Changed Selected DB ==> ", db);
    nonAuthInstance.defaults.headers.common["X-DB-KEY"] = db;
    axiosInstance.defaults.headers.common["X-DB-KEY"] = db;
};
